import {
    DIC
} from '@/const/dic'
import {
    validateChinese,
} from '@/util/validate'


const validateName = (rule, value, callback) => {
    if (!validateChinese(value) || value.length > 30 || value.length < 1) {
        callback(new Error('名称为1-30位中文'))
    } else {
        callback();
    }
}

export const shopTableOption = {
    align: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    index: false,
    selection: true,
    columnBtn: false,
    refreshBtn: true,
    saveBtn: false,
    updateBtn: false,
    cancelBtn: false,
    addBtn: false,
    delBtn: false,
    editBtn: false,
    page: false,
    menu: false,
    labelWidth: '100',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "账号",
            prop: "account",
            placeholder: "请输入账号",
            search: true,
            type: 'input',
            editVisdiplay: false,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入账号"
            }]
        },
        {
            label: "手机号码",
            prop: "mobile",
            placeholder: "请选择手机号码",
            type: "input",
            rules: [{
                required: true,
                trigger: "blur",
                max: 11,
                min: 11,
                message: "请选择手机号码"
            }]
        },
        // {
        //     label: "邮箱",
        //     prop: "eMail",
        //     type: "input"
        // },
        {
            label: "登录密码",
            placeholder: "请输入员工的登录密码",
            prop: "password",
            hide: true,
            type: "password",
            editVisdiplay: false
        },
        {
            label: "店铺名称",
            prop: "shopName",
            placeholder: "请输入店铺名称",
            search: true,
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                validator: validateName
            }]
        },
        {
            label: "店铺法人姓名",
            prop: "name",
            placeholder: "请输入店铺法人姓名",
            search: true,
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                validator: validateName
            }]
        },
        {
            label: '身份证正面',
            prop: 'dutyIdCardFrontImg',
            span: 24,
            hide: true,
            formsolt: true,
            solt: true,
            row: true
        },
        {
            label: '身份证反面',
            prop: 'dutyIdCardBackImg',
            span: 24,
            hide: true,
            formsolt: true,
            solt: true,
            row: true
        },
        {
            label: '营业执照',
            prop: 'businessLicense',
            span: 24,
            hide: true,
            formsolt: true,
            solt: true,
            row: true
        },
        {
            label: '省份',
            prop: 'provinceName',
            hide: true,
            formsolt: true
        }, {
            label: '城市',
            prop: 'cityName',
            hide: true,
            formsolt: true
        }, {
            label: '地区',
            prop: 'areaName',
            hide: true,
            formsolt: true
        },
        {
            label: "店铺地址",
            placeholder: "请输入店铺地址",
            prop: "address",
            search: true,
            type: "input"
        },
        {
            label: '店铺地址标记',
            prop: 'provincesPoInt',
            span: 24,
            solt: true,
            hide: true,
            formsolt: true
        },
        {
            label: "状态",
            prop: "approveStatus",
            type: "radio",
            dicData: DIC.SHOP_APPROVE_STATUS,
            sortable: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "创建人",
            prop: "createBy",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },

        {
            label: "更新时间",
            prop: "updateTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新人",
            prop: "updateBy",
            type: "input",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "是否删除",
            prop: "deleteFlag",
            type: "radio",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            dicData: DIC.DELETE_FLAG
        },
        {
            label: "备注",
            prop: "remarks",
            type: "textarea",
            span: 24,
            hide: true,
            max: 255
        }


    ]
};